// @ts-nocheck 8c6ea73e
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['add_section_label_toggle_switch'],
      sections: [addPanel.sections.getSections().developer.toggleSwitchSection],
    };
  },
};
